import React from "react";
import { BaseTabedPage, BaseTabedPageWhitoutRoute } from "../../../../_metronic/layout/components/common/baseTabedPage";
import ProvincePage from "./ProvincePage";
import TownPage from "./TownPage";


const components = [
  { id: 1, title: "استان", tab: 'provinces', component: <ProvincePage key={1} /> },
  { id: 2, title: "شهرستان", tab: 'towns', component: <TownPage key={2} /> },
];

export const ProvinceBasePage = () => {
  return (
    <BaseTabedPageWhitoutRoute components={components} />
  );
}
